'use strict';
var SignupEvents = /** @class */ (function () {
    function SignupEvents() {
        'ngInject';
        this.practitionerSignUpTrackingEvents = {
            'isResale': {
                eventCategory: 'practitioner signup',
                eventLabel: 'select yes',
                eventAction: 'step 1'
            },
            'isPersonal': {
                eventCategory: 'patient signup',
                eventLabel: 'select no',
                eventAction: 'step 1'
            },
            'selectEmail': {
                eventCategory: 'practitioner signup',
                eventLabel: 'fill email',
                eventAction: 'general info'
            },
            'emailError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'invalid email',
                eventAction: 'general info'
            },
            'selectDesignations': {
                eventCategory: 'practitioner signup',
                eventLabel: 'fill designations',
                eventAction: 'general info'
            },
            'designationsError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'invalid designations',
                eventAction: 'general info'
            },
            'selectTitle': {
                eventCategory: 'practitioner signup',
                eventLabel: 'select title',
                eventAction: 'general info'
            },
            'selectFirstName': {
                eventCategory: 'practitioner signup',
                eventLabel: 'fill first name',
                eventAction: 'general info'
            },
            'firstNameError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'first name missing',
                eventAction: 'general info'
            },
            'selectMI': {
                eventCategory: 'practitioner signup',
                eventLabel: 'fill MI',
                eventAction: 'general info'
            },
            'selectLastName': {
                eventCategory: 'practitioner signup',
                eventLabel: 'fill last name',
                eventAction: 'general info'
            },
            'lastNameError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'last name missing',
                eventAction: 'general info'
            },
            'selectSuffix': {
                eventCategory: 'practitioner signup',
                eventLabel: 'select suffix',
                eventAction: 'general info'
            },
            'createPassword': {
                eventCategory: 'practitioner signup',
                eventLabel: 'select password',
                eventAction: 'create password'
            },
            'createPasswordError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'invalid password',
                eventAction: 'create password'
            },
            'verifyPassword': {
                eventCategory: 'practitioner signup',
                eventLabel: 'verify password',
                eventAction: 'create password'
            },
            'verifyPasswordError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'password not match',
                eventAction: 'create password'
            },
            'continue': {
                eventCategory: 'practitioner signup',
                eventLabel: 'click continue',
                eventAction: 'continue'
            },
            'continueError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'click continue while button disabled',
                eventAction: 'continue'
            },
            'selectBusinessName': {
                eventCategory: 'practitioner signup',
                eventLabel: 'fill business name',
                eventAction: 'professional info'
            },
            'businessNameError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'business name is missing',
                eventAction: 'professional info'
            },
            'selectPhone': {
                eventCategory: 'practitioner signup',
                eventLabel: 'fill phone number',
                eventAction: 'professional info'
            },
            'phoneError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'invalid phone number',
                eventAction: 'professional info'
            },
            'selectAddress1': {
                eventCategory: 'practitioner signup',
                eventLabel: 'fill address 1',
                eventAction: 'professional info'
            },
            'address1Error': {
                eventCategory: 'practitioner signup',
                eventLabel: 'address 1 missing',
                eventAction: 'professional info'
            },
            'selectAddress2': {
                eventCategory: 'practitioner signup',
                eventLabel: 'fill address 2',
                eventAction: 'professional info'
            },
            'address2Error': {
                eventCategory: 'practitioner signup',
                eventLabel: 'invalid address 2',
                eventAction: 'professional info'
            },
            'selectCountry': {
                eventCategory: 'practitioner signup',
                eventLabel: 'select country',
                eventAction: 'professional info'
            },
            'countryError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'invalid country',
                eventAction: 'professional info'
            },
            'selectState': {
                eventCategory: 'practitioner signup',
                eventLabel: 'select state',
                eventAction: 'professional info'
            },
            'stateError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'error in state',
                eventAction: 'professional info'
            },
            'selectCity': {
                eventCategory: 'practitioner signup',
                eventLabel: 'fill city',
                eventAction: 'professional info'
            },
            'cityError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'error in city',
                eventAction: 'professional info'
            },
            'selectPostalCode': {
                eventCategory: 'practitioner signup',
                eventLabel: 'fill postal code',
                eventAction: 'professional info'
            },
            'postalCodeError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'invalid postal code',
                eventAction: 'professional info'
            },
            'selectCredential': {
                eventCategory: 'practitioner signup',
                eventLabel: 'select credential',
                eventAction: 'certification'
            },
            'uploadCredential': {
                eventCategory: 'practitioner signup',
                eventLabel: 'upload credential',
                eventAction: 'certification'
            },
            'uploadCredentialError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'click browse button while disabled',
                eventAction: 'certification'
            },
            'back': {
                eventCategory: 'practitioner signup',
                eventLabel: 'click back',
                eventAction: 'submit'
            },
            'submit': {
                eventCategory: 'practitioner signup',
                eventLabel: 'click submit',
                eventAction: 'submit'
            },
            'submitError': {
                eventCategory: 'practitioner signup',
                eventLabel: 'click submit while disabled',
                eventAction: 'submit'
            },
        };
        this.practitionerSignUpGTMTrackingEvents = {
            'customerSignup': {
                event: 'customerSignup',
                customerType: 'practitioner',
                practitionerId: '',
                eventTimestamp: '',
                practiceType: '',
            }
        };
    }
    return SignupEvents;
}());
export { SignupEvents };
//# sourceMappingURL=signup-events.js.map